import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const PaymentMethodsQuery = gql`
  query ($country: String) {
    paymentMethods(where: { country: $country }) {
      id
      tags
      name
      description
      price
      image
      gateway
      priority
      prices {
        currencyId
        priceWithout
      }
      countries {
        id
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  ids?: Array<string>;
  country?: string;
}

interface IResponse {
  data: any;
}

class GetPaymentMethodsQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { paymentMethods }: any = this.props;
    return this.props.children({
      paymentMethods
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(PaymentMethodsQuery, {
    name: 'paymentMethods'
  })
)(GetPaymentMethodsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/PaymentMethods/PaymentMethods.tsx